import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'swiper/css';
import './styles/tailwind.css';
import './index.css';
import './i18n';

const container = document.querySelector('#root') as Element;
const root = createRoot(container);

root.render(<App />);
